import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/services';
import { useAppointmentListClient } from './useGetAppointmentList';

export type SyncAppointmentRecord = {
  row_number: number;
  appt_notes: string;
  misc_column: string;
  appointment: {
    appointment_status: string;
    created_time: string;
    start_time: string;
    practitioner_name: string;
    condition_name: string;
  };
  patient: {
    birth_date: string;
    name: string;
    ehr_id: string;
    gender: string;
    address: {
      line_1: string;
      line_2: string;
      city: string;
      state: string;
      zip: string;
    };
    phone: string;
    email: string;
  };
};

export type SyncAppointmentsPayload = {
  s3_key: string;
  appointments: SyncAppointmentRecord[];
};

export type SyncAppointmentsResponse = {
  created?: number;
  updated?: number;
  skipped?: number;
  errors?: string[];
};

export const useSyncAppointments = () => {
  const { invalidate } = useAppointmentListClient();
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ['syncAppointments'],
    mutationFn: (payload: SyncAppointmentsPayload) =>
      api
        .post<SyncAppointmentsResponse>('/appointments/sync', payload)
        .then((res) => res.data),
    onSuccess: () => {
      invalidate();
      queryClient.invalidateQueries({
        queryKey: ['bulkAppointmentUploadHistory'],
      });
    },
  });
};
